<template lang='pug' src='./appointment-thank-you.pug'></template>

<script>
import Icon from 'components/icon/icon'

export default {
  components: {
    Icon
  }
}
</script>



// WEBPACK FOOTER //
// appointment-thank-you.vue?72320a6f